
import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const VerticalMovementPage = lazy(() => import('./RenewMovementPage'));

const path = 'reports/renew-movement';
const VerticalMovementRoute: FuseRouteItemType = {
	path: path,
	element: <VerticalMovementPage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Renew Movement',
					helpName: 'Renew Movement'
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default VerticalMovementRoute;
